import axios from "axios";
import { getLocale } from "@/services/locale.service";

const PASSWORD_HINTS_CULTURES = {
  en: "en",
  zh_hk: "zh-HK",
  zh_cn: "zh-CN"
};

function getCurrentLocale() {
  try {
    const root = document.getElementById("app")?.__vue__;
    if (root?.$i18n?.locale) {
      return root.$i18n.locale;
    }
  } catch {
    // ignore and fall back
  }
  return getLocale();
}

// #21867 Add culture for NexTore API getPasswordHints
axios.interceptors.request.use(
  function (config) {
    try {
      const url = new URL(config.url || "", window.location.origin);

      if (
        (config.method || "get").toLowerCase() === "get" &&
        url.pathname.toLowerCase() === "/api/user/getpasswordhints"
      ) {
        config.params = config.params instanceof URLSearchParams
          ? config.params
          : new URLSearchParams(
              typeof config.params === "object" && config.params
                ? config.params
                : undefined
            );
        config.params.set(
          "culture",
          PASSWORD_HINTS_CULTURES[getCurrentLocale()] || "en"
        );
      }
    } catch {
      // ignore and let request continue
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
